import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/')({
  component: () => null,
  /**
   * Redirect users from the previous playground structure to the new one.
   */
  loader: async ({ location }) => {
    const { chatId, ...restSearch } = location.search as {
      chatId: string;
      [key: string]: string;
    };

    if (chatId) {
      throw redirect({
        to: '/$chatId',
        params: { chatId },
        search: restSearch,
      });
    }

    return {};
  },
});
